import { ReactElement } from 'react';

import { Background } from '../../stories/Background/Background';

interface LayoutProps {
  children: ReactElement;
}

const Layout = ({ children }: LayoutProps) => {
  return <Background>{children}</Background>;
};

export default Layout;
